// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Vj2nl","content":"styles_content__ixbQr"};